
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/DebouncedModel.js");

module.exports = Model({
	name: "requests",
	init: init,
	listeners: listeners,
	triggers: triggers,
	debounce: 100, // Debounce pushes by 50 milliseconds
});

function init() {
	this.push({
		incoming: [],
		outgoing: [],
		invites: [],
		denying: null,
		shouldBlock: false,
		unblocking: false,
	});
}

/**
 * Listen for updates to the lists of incoming and outgoing contact requests
 * @return {[type]} [description]
 */
function listeners() {
	return {
		"incomingrequests:updated": handle_incoming_update,
		"outgoingrequests:updated": handle_outgoing_update,
		"blocking:unblocking": handle_blocking_update,
		"accountinvites:updated": handle_invite_update
	};
}

function triggers() {
	return {
		"request": handle_trigger_request,
		"accept": handle_trigger_accept,
		"deny": handle_trigger_deny,
		"deny:confirm": handle_trigger_deny_confirm,
		"deny:cancel": handle_trigger_deny_cancel,
		"cancel": handle_trigger_cancel,
		"unblock:reset": handle_unblock_deny,
		"block:set": handle_trigger_block_set
	};
}

function handle_incoming_update(incoming) {
	this.extend({
		incoming: incoming
	});
}

function handle_outgoing_update(outgoing) {
	this.extend({
		outgoing: outgoing
	});
}

function handle_invite_update(invites) {
	this.extend({
		invites: invites
	});
}

function handle_trigger_accept(data) {
	this.api.contacts.requests.accept(data.request);

	this.emit("toast:trigger:show", {
		content: "contactlist.requestaccept",
	});

	this.emit("usermetrics:trigger:track", "accept contact request", {
		who: data.who,
	});
}

function handle_trigger_deny(data) {
	this.extend({
		denying: data
	});

	this.emit("usermetrics:trigger:track", "open deny contact request popup", {
		who: data.who,
	});
}

function handle_trigger_deny_confirm(triggerData) {
	var who = triggerData.who;
	var request = triggerData.request;
	var shouldBlock = this.data.shouldBlock;
	this.api.contacts.requests
		.deny(request)
		.then(handle_deny_success.bind(this))
		.catch(handle_deny_error.bind(this));

	if (shouldBlock) {
		this.emit("usermetrics:trigger:track", "deny contact request and block", {
			who,
		});
		this.emit("blocking:trigger:block", {
			who: who
		});
	} else {
		this.emit("usermetrics:trigger:track", "deny contact request", {
			who,
		});
	}
}

function handle_trigger_deny_cancel() {
	this.extend({
		denying: null
	});
	this.emit("usermetrics:trigger:track", "close deny contact request popup");
}

function handle_deny_success() {
	this.extend({
		denying: null
	});
	this.emit("toast:trigger:show", {
		content: "contactlist.requestdeny",
	});
}

function handle_deny_error(e) {
	console.error(e);
	this.emit("toast:trigger:show", {
		content: "generalerror.error",
		style: "error"
	});
}

function handle_trigger_cancel(data) {
	this.emit("save:trigger:start");
	this.api.contacts.requests.cancel(data.request)
		.catch(requestFinished.bind(this))
		.then(requestFinished.bind(this));
	this.emit("usermetrics:trigger:track", "cancel contact request", { who: data.who });
}

function handle_trigger_request(data) {
	this.emit("save:trigger:start");
	var who = data.who;
	this.api.contacts.requests
		.request(who)
		.then(clear_search.bind(this))
		.then(dispatch_added.bind(this, who))
		.catch(handle_request_error.bind(this))
		.then(requestFinished.bind(this));

	this.emit("usermetrics:trigger:track", "send contact request", {
		who,
	});
}

function requestFinished() {
	this.emit("save:trigger:finish");
	this.extend({
		denying: null
	});
}

function dispatch_added(who) {
	this.dispatch("added", {
		who: who
	});
	this.emit("toast:trigger:show", {
		content: "contactlist.requestsend",
	});
}

function clear_search() {
	this.emit("search:trigger:clear");
}

function handle_trigger_block_set(data){
	var block = data.block;

	this.extend({
		shouldBlock: block
	});
}

function handle_blocking_update(){
	this.extend({
		unblocking: true
	});
	this.emit("usermetrics:trigger:track", "open unblock contact in contact request");
}

function handle_unblock_deny(){
	this.extend({
		unblocking: false
	});
	this.emit("usermetrics:trigger:track", "close unblock contact in contact request");
}

function handle_request_error(e) {
	console.error(e);
	this.emit("toast:trigger:show", {
		content: "contactlist.requesterror",
		style: "error"
	});
}
